import _typeof from "@babel/runtime/helpers/esm/typeof";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import React, { useRef, useState } from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { Flex, Text } from '@magalu/stereo-ui/atoms';
import withLayoutProps from '../../../hocs/withLayoutProps';
import { useReviewInputValidation } from '../../../hooks';
import { useReview } from '@magalu/mixer-graphql';
import useUserData from '../../../hooks/useUserData';
import ReviewModal from '../ReviewModal';
import { usePublisher } from '@magalu/mixer-publisher';
import { uploadMediaReview } from './services/sendMediaReview';
import AttachReviewMedia from './components/AttachReviewMedia';
import RatingComment from './components/RatingComment';
import RatingInput from './components/RatingInput';
import { RoundedButton } from './components/AttachReviewMedia/AttachReviewMedia.styles';
import { MAX_COMMENT_LENGTH } from './constants';
var ProductReviewForm = function ProductReviewForm(_ref) {
  var _data$product, _data$product$seller, _structure$route, _structure$config, _structure$config$rev, _data$product2, _data$product2$seller, _data$product3, _data$categoryDimensi;
  var data = _ref.data,
    structure = _ref.structure,
    staticProps = _ref["static"];
  var channel = staticProps.channel;
  var sku = (data == null ? void 0 : (_data$product = data.product) == null ? void 0 : (_data$product$seller = _data$product.seller) == null ? void 0 : _data$product$seller.sku) || (structure == null ? void 0 : (_structure$route = structure.route) == null ? void 0 : _structure$route.productId) || '';
  var isEnableSeller = (structure == null ? void 0 : (_structure$config = structure.config) == null ? void 0 : (_structure$config$rev = _structure$config.review) == null ? void 0 : _structure$config$rev.toogleEnableSellerId) === (data == null ? void 0 : (_data$product2 = data.product) == null ? void 0 : (_data$product2$seller = _data$product2.seller) == null ? void 0 : _data$product2$seller.id);
  var productImageUrl = (data == null ? void 0 : (_data$product3 = data.product) == null ? void 0 : _data$product3.image) || '';
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    rating = _useState2[0],
    setRating = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    errors = _useState4[0],
    setErrors = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    statusMessage = _useState6[0],
    setStatusMessage = _useState6[1];
  var _useState7 = useState((data == null ? void 0 : (_data$categoryDimensi = data.categoryDimensions) == null ? void 0 : _data$categoryDimensi.dimensions) || []),
    _useState8 = _slicedToArray(_useState7, 2),
    dimensionsRating = _useState8[0],
    setDimensionsRating = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    comment = _useState10[0],
    setComment = _useState10[1];
  var _useState11 = useState({
      attachedMedia: [],
      shownMedia: []
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedMedia = _useState12[0],
    setSelectedMedia = _useState12[1];
  var _usePublisher = usePublisher(),
    publish = _usePublisher.publish;
  var setLoading = function setLoading(loading) {
    return publish('page:loading', loading);
  };
  var _useReview = useReview(),
    createUserReviewSubmission = _useReview.createUserReviewSubmission;
  var refs = _extends({
    comment: useRef(null),
    rating: useRef(null)
  }, dimensionsRating == null ? void 0 : dimensionsRating.reduce(function (acc, _ref2) {
    var id = _ref2.id;
    return _extends({}, acc, _defineProperty({}, id, useRef(null)));
  }, {}));
  var changeDimensionsRating = function changeDimensionsRating(e, id) {
    setDimensionsRating(function (prevDimensions) {
      return prevDimensions == null ? void 0 : prevDimensions.map(function (dimension) {
        return dimension.id === id ? _extends({}, dimension, {
          value: e.target.value
        }) : dimension;
      });
    });
  };
  var updateErrors = function updateErrors(key, error) {
    setErrors(function (prevErrors) {
      var newErrors = _extends({}, prevErrors, error);
      if (!error) {
        delete newErrors[key];
      }
      if (typeof window !== 'undefined' && window.focus && newErrors[key]) {
        var current = refs[key].current;
        current == null ? void 0 : current.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
      return newErrors;
    });
  };
  var validateComment = function validateComment(id, value) {
    var inputValidation = useReviewInputValidation(value, rating);
    var error = (!(inputValidation == null ? void 0 : inputValidation.valid) || (inputValidation == null ? void 0 : inputValidation.textColor) === 'text.light') && _defineProperty({}, id, inputValidation);
    updateErrors(id, error);
    return error;
  };
  var validateRating = function validateRating(id, value) {
    var error = !value ? _defineProperty({}, id, 'Clique nas estrelas para classificar o produto') : undefined;
    updateErrors(id, error);
    return error;
  };
  var clearForm = function clearForm() {
    var _data$categoryDimensi2;
    setRating(0);
    setComment('');
    setDimensionsRating((data == null ? void 0 : (_data$categoryDimensi2 = data.categoryDimensions) == null ? void 0 : _data$categoryDimensi2.dimensions) || []);
    setSelectedMedia({
      attachedMedia: [],
      shownMedia: []
    });
  };
  var handleSendReview = function () {
    var _ref5 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee(userDataHandler, medias) {
      var _structure$config2, _structure$config3, _structure$query, _data$product4, _data$product5, _data$product6, _data$product6$seller, _structure$route2, _result$createUserRev;
      var images, videos, basePath, _yield$createUserRevi, result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            images = [];
            videos = [];
            basePath = (structure == null ? void 0 : (_structure$config2 = structure.config) == null ? void 0 : _structure$config2.desktopSiteDomain) || (structure == null ? void 0 : (_structure$config3 = structure.config) == null ? void 0 : _structure$config3.canonicalDomain);
            medias == null ? void 0 : medias.forEach(function (elem) {
              if (elem.mediaType === 'video') {
                videos.push(elem.mediaId);
              } else {
                images.push(elem.mediaId);
              }
            });
            _context.next = 6;
            return createUserReviewSubmission({
              request: _extends({
                campaignId: !((_structure$query = structure.query) == null ? void 0 : _structure$query.rd) ? '' : 'CRM',
                channel: channel,
                description: comment,
                dimensions: dimensionsRating == null ? void 0 : dimensionsRating.map(function (_ref6) {
                  var id = _ref6.id,
                    value = _ref6.value,
                    label = _ref6.label;
                  return {
                    id: id,
                    label: label,
                    rating: value
                  };
                }),
                product: {
                  images: images,
                  productImageUrl: productImageUrl,
                  productLink: "".concat(basePath, "/").concat(data == null ? void 0 : (_data$product4 = data.product) == null ? void 0 : _data$product4.path),
                  productName: data == null ? void 0 : (_data$product5 = data.product) == null ? void 0 : _data$product5.title,
                  ratingValue: rating.toString(),
                  sku: sku,
                  videos: videos
                },
                rating: rating
              }, userDataHandler, {
                sellerId: data == null ? void 0 : (_data$product6 = data.product) == null ? void 0 : (_data$product6$seller = _data$product6.seller) == null ? void 0 : _data$product6$seller.id,
                variationId: structure == null ? void 0 : (_structure$route2 = structure.route) == null ? void 0 : _structure$route2.productId
              })
            }, {
              timeout: 8000
            });
          case 6:
            _yield$createUserRevi = _context.sent;
            result = _yield$createUserRevi.data;
            publish('product:reviewform:submit', comment, rating);
            setStatusMessage(result);
            publish('review:modal:open');
            if ((result == null ? void 0 : (_result$createUserRev = result.createUserReviewSubmission) == null ? void 0 : _result$createUserRev.status) === 'SUCCESS') {
              clearForm();
            }
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSendReview(_x, _x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var uploadMedia = function uploadMedia(userDataHandler) {
    var _data$product7, _data$product7$seller, _structure$config4, _userDataHandler$user, _structure$cookies, _structure$cookies$ac;
    var headers = {
      'marketplace-id': 'Magalu-Mktplace',
      'seller-id': data == null ? void 0 : (_data$product7 = data.product) == null ? void 0 : (_data$product7$seller = _data$product7.seller) == null ? void 0 : _data$product7$seller.id,
      sku: sku
    };
    var attachedMedia = selectedMedia.attachedMedia;
    var uploadedMedias = [];
    setLoading(true);
    var customerId = (structure == null ? void 0 : (_structure$config4 = structure.config) == null ? void 0 : _structure$config4.isMiniApp) ? (_userDataHandler$user = userDataHandler.userData) == null ? void 0 : _userDataHandler$user.customerId : structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : (_structure$cookies$ac = _structure$cookies.accountData) == null ? void 0 : _structure$cookies$ac.id;
    attachedMedia.forEach(function (elem) {
      return Promise.all([uploadMediaReview(headers, elem, structure, customerId)]).then(function (response) {
        uploadedMedias.push.apply(uploadedMedias, _toConsumableArray(response));
        if (uploadedMedias.length === attachedMedia.length) {
          setLoading(false);
          handleSendReview(userDataHandler, uploadedMedias);
        }
      })["catch"](function () {
        var errorReturn = {
          createUserReviewSubmission: {
            description: 'Não foi possível enviar os arquivos. Tente novamente em alguns instantes!',
            msg: 'Erro ao fazer o envio de fotos e vídeos!',
            status: 'ERROR'
          }
        };
        setLoading(false);
        setStatusMessage(errorReturn);
        publish('review:modal:open');
      });
    });
  };
  var handleSubmit = function () {
    var _ref7 = _asyncToGenerator(_regeneratorRuntime().mark(function _callee2(e) {
      var errorsValidation, _structure$query2, _structure$config5, _structure$config5$re, user, userDataHandler, _structure$query3, shouldAttachMedia;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            e.preventDefault();
            errorsValidation = _extends({}, validateRating('rating', rating), dimensionsRating.reduce(function (acc, _ref8) {
              var id = _ref8.id,
                value = _ref8.value;
              return _extends({}, acc, validateRating(id, value));
            }, {}), Object.entries(validateComment('comment', comment)).filter(function (_ref9) {
              var _ref10 = _slicedToArray(_ref9, 2),
                value = _ref10[1];
              return value.valid !== true;
            }));
            if (Object.keys(errorsValidation).length) {
              _context2.next = 10;
              break;
            }
            _context2.next = 5;
            return useUserData({
              structure: structure
            });
          case 5:
            user = _context2.sent;
            userDataHandler = null;
            if (structure == null ? void 0 : (_structure$query2 = structure.query) == null ? void 0 : _structure$query2.rd) {
              userDataHandler = {
                userDataJWT: structure == null ? void 0 : (_structure$query3 = structure.query) == null ? void 0 : _structure$query3.rd
              };
            } else {
              userDataHandler = {
                userData: {
                  customerId: user.id,
                  email: user.email,
                  name: user.name
                }
              };
            }
            shouldAttachMedia = ((structure == null ? void 0 : (_structure$config5 = structure.config) == null ? void 0 : (_structure$config5$re = _structure$config5.review) == null ? void 0 : _structure$config5$re.toggleEnableAttachMedia) || isEnableSeller) && selectedMedia.attachedMedia.length > 0;
            if (shouldAttachMedia) {
              uploadMedia(userDataHandler);
            } else {
              handleSendReview(userDataHandler);
            }
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleSubmit(_x3) {
      return _ref7.apply(this, arguments);
    };
  }();
  var handleComment = function handleComment(e) {
    validateComment('comment', e.target.value);
    setComment(e.target.value);
  };
  var renderAttachMediaBlock = function renderAttachMediaBlock() {
    var _structure$config6, _structure$config6$re;
    return ((structure == null ? void 0 : (_structure$config6 = structure.config) == null ? void 0 : (_structure$config6$re = _structure$config6.review) == null ? void 0 : _structure$config6$re.toggleEnableAttachMedia) || isEnableSeller) && React.createElement(AttachReviewMedia, {
      selectedMedia: selectedMedia,
      setSelectedMedia: setSelectedMedia
    });
  };
  return React.createElement(Flex, {
    flexDirection: "column",
    as: "form",
    onSubmit: handleSubmit
  }, React.createElement(RatingInput, {
    label: "O que voc\xEA achou desse produto?",
    variant: "large",
    showLabel: true,
    value: rating,
    error: errors.rating,
    onChange: function onChange(e) {
      validateRating('rating', e.target.value);
      setRating(e.target.value);
    },
    name: "rating",
    ref: refs.rating
  }), React.createElement(Flex, {
    flexDirection: "column",
    mt: 4,
    gap: "24px",
    pr: [0, 80]
  }, dimensionsRating.length > 0 && React.createElement(Text, {
    lineHeight: "fontSize",
    fontWeight: "medium",
    fontSize: [3, 5]
  }, "Como voc\xEA avalia as caracter\xEDsticas abaixo?"), dimensionsRating == null ? void 0 : dimensionsRating.map(function (_ref11) {
    var id = _ref11.id,
      label = _ref11.label,
      value = _ref11.value;
    return React.createElement(RatingInput, {
      key: id,
      label: label,
      showLabel: false,
      value: value,
      onChange: function onChange(e) {
        validateRating(id, e.target.value);
        changeDimensionsRating(e, id);
      },
      name: id,
      error: errors[id],
      ref: refs[id]
    });
  })), renderAttachMediaBlock(), React.createElement(Flex, {
    mt: "32px"
  }, React.createElement(RatingComment, {
    ref: refs.comment,
    error: errors.comment,
    rating: rating,
    onChange: function onChange(e) {
      handleComment(e);
    },
    value: comment,
    maxLength: MAX_COMMENT_LENGTH
  })), React.createElement(RoundedButton, {
    size: "large",
    full: true,
    uppercase: false,
    mt: 32,
    mb: [32, 80],
    variation: "outline",
    maxWidth: "568px",
    type: "submit",
    "data-testid": "button-submit"
  }, "Enviar Avalia\xE7\xE3o"), React.createElement(ReviewModal, {
    data: data,
    structure: structure,
    variant: statusMessage,
    "static": staticProps
  }));
};
process.env.NODE_ENV !== "production" ? ProductReviewForm.propTypes = {
  data: shape({
    categoryDimensions: shape({
      dimensions: arrayOf(shape({}))
    })
  }),
  "static": shape({
    channel: string
  }),
  structure: shape({})
} : void 0;
ProductReviewForm.defaultProps = {
  data: {
    categoryDimensions: {
      dimensions: []
    }
  },
  "static": {},
  structure: {}
};
ProductReviewForm.ssr = false;
export default withLayoutProps(ProductReviewForm);